module.exports = __webpack_public_path__ + "static/media/feat-tcr-img3.8e60c4c0.jpg";